import { Element } from 'react-scroll';
import React, { useState, useRef, useEffect } from "react";
import { LayoutGrid } from "../../components/layout-grid";
import { Cover } from "../../components/cover";

const Feature3 = () => {
  
  return (
    <Element name="component3" className="component lg:h-[100vh] sm:h-[90vh]">
      <div className="grid-cols-12 flex flex-col">
            <div className="h-screen flex flex-col items-center py-20 w-full">
              <div className="lg:text-4xl sm:text-3xl sm:text-center text-custom-blue lg:text-left">
                <div>
                  Plan your next trip on your terms
                </div>
              </div>
              <div className="lg:text-1xl  text-custom-blue lg:text-left sm:text-center lg:pt-7 sm:pt-3 sm:flex sm:justify-center">
                <div className='lg:w-full sm:w-3/4'>
                  In seconds, get tailored suggestions that fit your <Cover>budget</Cover> + <Cover>schedule</Cover> + <Cover>mood</Cover>
                </div>
              </div>
              <LayoutGrid cards={cards} />
            </div>
       </div>
    </Element>
  );
};

const SkeletonOne = () => {
  return (
    <div>
      <p className="font-normal lg:text-0_5xl my-4 max-w-lg text-custom-white">
        Goa + October is a match made in heaven. Approx budget including 5 day stay and flights would be around 20k per person.
      </p>
    </div>
  );
};
 
const SkeletonTwo = () => {
  return (
    <div>
      <p className="font-normal lg:text-0_5xl my-4 max-w-lg text-custom-white">
        Jaipur + 50k budget + 7 days + November = Perfect vacation
      </p>
    </div>
  );
};
const SkeletonThree = () => {
  return (
    <div>
      <p className="font-normal lg:text-0_5xl my-4 max-w-lg text-custom-white">
        If you have 3 days and 10k to spare, then you should definitely visit Manali in February
      </p>
    </div>
  );
};
const SkeletonFour = () => {
  return (
    <div>
      <p className="font-normal lg:text-0_5xl my-4 max-w-lg text-custom-white">
        Gokarna in budget of 15k for 4 days in December is a great idea
      </p>
    </div>
  );
};
 
const cards = [
  {
    id: 1,
    content: <SkeletonOne />,
    className: "md:col-span-2",
    thumbnail:
      "https://plus.unsplash.com/premium_photo-1664117436813-d33dfaa96c2b?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Z29hJTIwYmVhY2glMjBsYW5kc2NhcGV8ZW58MHx8MHx8fDA%3D",
  },
  {
    id: 2,
    content: <SkeletonTwo />,
    className: "col-span-1",
    thumbnail:
      "https://images.unsplash.com/photo-1572455323333-6facea9b5169?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8amFpcHVyJTIwbGFuZHNjYXBlfGVufDB8fDB8fHww",
  },
  {
    id: 3,
    content: <SkeletonThree />,
    className: "col-span-1",
    thumbnail:
      "https://images.unsplash.com/photo-1440470177828-6381dc5074ba?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bWFuYWxpJTIwbGFuZHNjYXBlfGVufDB8fDB8fHww",
  },
  {
    id: 4,
    content: <SkeletonFour />,
    className: "md:col-span-2",
    thumbnail:
      "https://plus.unsplash.com/premium_photo-1664123873245-bd178d77ca19?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Z29rYXJuYSUyMGxhbmRzY2FwZXxlbnwwfHwwfHx8MA%3D%3D",
  },
];

export default Feature3;
